import { SectionDate } from '@sr/types';

type DateRangeProps = {
  startDate: SectionDate | null | undefined;
  stopDate: SectionDate | null | undefined;
  isCurrent: boolean;
  currentDateString?: string | null;
};

const DateRange = ({
  startDate,
  stopDate,
  isCurrent,
  currentDateString,
}: DateRangeProps) => {
  const hasStartDate: boolean = startDate
    ? startDate.month != null || startDate.year != null
    : false;
  const hasStopDate: boolean = stopDate
    ? stopDate.month != null || stopDate.year != null
    : false;
  // Don't render anything if no dates
  if (!hasStartDate && !hasStopDate) return null;

  if (startDate && hasStartDate && isCurrent) {
    return (
      <span>
        {dateToString(startDate)} - {currentDateString || 'Current'}
      </span>
    );
  }

  if (startDate && stopDate && hasStartDate && hasStopDate) {
    return (
      <span>
        {dateToString(startDate)} - {dateToString(stopDate)}
      </span>
    );
  }

  if (startDate && hasStartDate && !hasStopDate) {
    return <span>{dateToString(startDate)}</span>;
  }

  if (stopDate && !hasStartDate && hasStopDate) {
    return <span>{dateToString(stopDate)}</span>;
  }

  return null;
};

const hasStartOrStopDate = (
  startDate: SectionDate | null | undefined,
  stopDate: SectionDate | null | undefined
): boolean => {
  const hasStartDate: boolean = startDate
    ? startDate.month != null || startDate.year != null
    : false;
  const hasStopDate: boolean = stopDate
    ? stopDate.month != null || stopDate.year != null
    : false;
  return hasStartDate || hasStopDate;
};

function dateToString(date: SectionDate): string | null | undefined {
  if (!date.year && !date.month) return null;
  if (date.year && !date.month) return date.year.toString();
  if (!date.year && date.month) return monthNumberToString(date.month);

  if (date.year && date.month) {
    return `${monthNumberToString(date.month)} ${date.year.toString()}`;
  }
}

function monthNumberToString(monthNumber: number | null | undefined): string {
  switch (monthNumber) {
    case 1:
      return 'Jan';
    case 2:
      return 'Feb';
    case 3:
      return 'Mar';
    case 4:
      return 'Apr';
    case 5:
      return 'May';
    case 6:
      return 'Jun';
    case 7:
      return 'Jul';
    case 8:
      return 'Aug';
    case 9:
      return 'Sep';
    case 10:
      return 'Oct';
    case 11:
      return 'Nov';
    case 12:
      return 'Dec';
    default:
      return '';
  }
}

export { hasStartOrStopDate };
export default DateRange;
